/* eslint-disable no-bitwise */

/**
 * @summary Cria uma função de Caesar cipher
 * @param {string} secret - Chave que irá embaralhar a string para ser criptografada.
 * @returns Retorna uma função de criptografar.
 */
const Cipher = (secret) =>
{
	 const textToChars = text => text.split("").map(c => c.charCodeAt(0));
	 const byteHex = n => (`0${Number(n).toString(16)}`).substr(-2);
	 const applySaltToChar = code => textToChars(secret).reduce((a, b) => a ^ b, code);

	 return text => text.split("")
		 .map(textToChars)
		 .map(applySaltToChar)
		 .map(byteHex)
		 .join("");
};

/**
	* @summary Cria uma função para ler uma Caesar cipher
	* @param {string} secret - Chave que irá dembaralhar a string para ser criptografada.
	* @returns Retorna uma função de desemcriptografar.
	*/
const Decipher = (secret) =>
{
	 const textToChars = text => text.split("").map(c => c.charCodeAt(0));
	 const applySaltToChar = code => textToChars(secret).reduce((a, b) => a ^ b, code);
	 return encoded => encoded.match(/.{1,2}/g)
		 .map(hex => parseInt(hex, 16))
		 .map(applySaltToChar)
		 .map(charCode => String.fromCharCode(charCode))
		 .join("");
};

export default
{
	 Cipher,
	 Decipher,
};

